import { Button, Flex, FormCheckbox, Text } from '@spotify-internal/encore-web';
import { ConfidenceWebsiteLinkEncore } from '@spotify/confidence-core-react';

import { useCreateAccountFormContext } from './CreateAccountFormProvider';

export const CreateWorkspaceFooter = () => {
  const {
    canSubmit,
    acceptMarketingEmails,
    setAcceptMarketingEmails,
    handleCreate,
  } = useCreateAccountFormContext();
  return (
    <Flex direction="column" gap="tighter">
      <FormCheckbox
        id="marketing-emails"
        name="marketing-emails"
        checked={acceptMarketingEmails}
        onChange={() => setAcceptMarketingEmails(!acceptMarketingEmails)}
      >
        Send me tips and updates about Confidence. Unsubscribe at any time.
      </FormCheckbox>
      <Text variant="bodySmall" semanticColor="textSubdued">
        By selecting &quot;Create workspace&quot;, you agree to the{' '}
        <ConfidenceWebsiteLinkEncore route="/terms-of-service">
          Terms of Service
        </ConfidenceWebsiteLinkEncore>
        .
      </Text>
      <Button
        variant="primary"
        size="large"
        fullWidth
        disabled={!canSubmit}
        onClick={handleCreate}
      >
        Create workspace
      </Button>
    </Flex>
  );
};
